<template>
  <div ref="filePreviewDiv" style="width: 100%; height: 100%; overflow: auto;">
    <canvas id="filePreview" style="display:block;margin: 0 auto" />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ImagePreviewCwmi',
  props: {
    imageInfo: {
      type: Object,
      default: () => ({})
    },
    curFocus: {
      type: String,
      default: () => null
    },
    resultArray: { type: Array, default: () => [] }
  },
  data() {
    return {
      ctx: null,
      proportion: 1,
      img: null,
      loading: null,
      coordinateFlag: false // 坐标是否开启
    }
  },
  watch: {
    imageInfo(val) {
      if (val) {
        this.init(val)
      }
    }
    // ,
    // curFocus(val, oldVal) {
    //   if (val !== oldVal) {
    //     this.curFocusChange(val)
    //   }
    // }
  },
  async mounted() {
    await cache.load(cacheName.CONFIG)
    this.coordinateFlag = parseInt(cache.config.get('OCRHighlight')) === 1
    this.init(this.imageInfo)
  },
  methods: {
    async init(imageInfo) {
      const loading = getLoading('intelligent-booking-result-dialog')
      const { imgPath } = imageInfo
      this.img = new Image()
      this.img.onload = () => {
        // this.drawMain(imageInfo)
        this.curFocusChange(this.imageInfo.curFocus)
        loading.close()
      }
      this.img.onerror = () => {
        this.$message.error(this.$t('SeaExport.PictureLoadingFailed'))
        loading.close()
      }
      this.img.src = imgPath
    },
    curFocusChange(val) {
      console.log('curFocus:', val)
      this.drawMain(this.imageInfo)
      if (this.coordinateFlag && this.imageInfo.data) {
        if (val in this.imageInfo.data) {
          // console.log('this.imageInfo.pointer[val]:', this.imageInfo.data[val])
          const { x, y, width, height } = this.imageInfo.data[val]
          this.preRect = [x * this.proportion, y * this.proportion, width * this.proportion, height * this.proportion]
          this.ctx.strokeStyle = 'red'
          console.log('this.proportion:', this.proportion)
          console.log('this.imgWidth:', this.img.width)
          console.log('this.imgHeight:', this.img.height)
          console.log('this.preRect:', this.preRect)
          console.log('this.imageInfo.data[val]:', this.imageInfo.data[val])
          this.ctx.strokeRect(...this.preRect)
          this.$refs.filePreviewDiv.scrollTo({ behavior: 'smooth', left: (x * this.proportion) - document.body.clientWidth / 3, top: (y * this.proportion) - document.body.clientHeight / 3 })
        }
      }
    },
    drawMain(imageInfo) {
      const canvas = document.getElementById('filePreview')
      const { imgWidth, imgHeight } = imageInfo
      // const imgWidth = this.img.width
      // const imgHeight = this.img.height
      const newWidth = document.body.clientWidth / 2 < 800 ? 800 : document.body.clientWidth / 2
      this.proportion = newWidth / imgWidth
      const newHeight = imgHeight * this.proportion
      if (canvas) {
        canvas.width = newWidth
        canvas.height = newHeight
        this.ctx = canvas.getContext('2d')
        this.ctx.drawImage(this.img, 0, 0, imgWidth, imgHeight, 0, 0, newWidth, newHeight)
      }
    }
  }
}
</script>

<style scoped>

</style>
